import { refreshSharingTipsForLink, updateSharePointLinkUrl } from '../actions/publicActions';
import getSharingLink from '../selectors/getSharingLink';
import { createSharingLink } from '../services/createSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { ignoreExpirationDate, refreshExpirationDate } from 'owa-sharing-data';
import { orchestrator } from 'satcheljs';

orchestrator(refreshExpirationDate, async actionMessage => {
    if (typeof actionMessage.id === 'string') {
        const sharingLink: SharingLinkInfo = getSharingLink(<string>actionMessage.id);
        if (!!sharingLink) {
            const newLink = await createSharingLink(
                sharingLink.sharingInfo.canonicalUrl,
                sharingLink.permissionLevel
            );
            updateSharePointLinkUrl(sharingLink.linkId, newLink.Link, sharingLink.url);

            // TODO VSO 37982 - since we do not get a new expiration date back when we refresh the link
            // we are ignoring the expiration date after refresh
            // Decide if this is okay, or if we need to return the expiration date, or
            ignoreExpirationDate(sharingLink.linkId);
            refreshSharingTipsForLink(sharingLink.linkId);
        }
    }
});
